module.exports = __webpack_public_path__ + "static/media/detalle-rojo.fda9c212.svg";